import React, { useRef, useState } from 'react';
import Hero from './hero';
import LandingPage from './landing-page';
import LandingFooter from './landing-footer';
import { LoaderCircle } from 'lucide-react';
import Image from 'next/image';
import SearchError from './search-error';
import SearchResult from './search-result';
import { postShadowbanRiskApi } from '@/lib/service/shadowban-test';
import Searching from './searching';
import { useTranslation } from 'next-i18next';
import styles from './indexMain.module.less';

export type ITab = {
  tab: 'twitter' | 'instagram' | 'tiktok';
  title: 'Twitter' | 'Instagram' | 'TikTok';
  href: string;
  icon: string;
};

interface MyTaskType {
  id: string;
  status?: 'pending' | 'processing' | 'completed' | 'failed';
  result?: any;
}

const Index: React.FC<{ content: any; defaultTab?: ITab['tab']; isSubPage?: boolean }> = ({
  content,
  defaultTab = 'twitter',
  isSubPage = false,
}) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState<ITab['tab']>(defaultTab);
  const inputRef = useRef<HTMLInputElement>(null);
  const [myTask, setMyTask] = useState<MyTaskType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const resultRef = useRef<HTMLDivElement>(null); // 结果组件的 ref
  const [data, setData] = useState<any>({});

  async function startShadowbanAction() {
    if (loading) return;
    const checkInfo = inputRef.current?.value.trim();
    if (!checkInfo) return;

    // 模拟数据请求
    setLoading(true);
    // message.info("type：" + currentTab + "，query：" + checkInfo)
    // 模拟数据
    setMyTask({
      id: Math.random().toString(36).substring(2, 15),
    });

    const res = await postShadowbanRiskApi({
      check_info: checkInfo,
      platform: currentTab === 'twitter' ? 'x' : currentTab,
    });

    // setData({
    //   "task": {
    //     "id": "7617232",
    //     "username": "zy",
    //     "url": "https://x.com/ZY",
    //     "platform": "x",
    //     "name": "ZY",
    //     "image": "https://pbs.twimg.com/profile_images/989715445597913089/ssBuYVpu_normal.jpg",
    //     "post_count": 1,
    //     "like_count": null,
    //     "follower_count": 156,
    //     "following_count": 110,
    //     "is_verified": true,
    //     "risk": "Low"
    //   },
    //   "suggest_ban": "Low",
    //   "search_ban": "Low",
    //   "ghost_ban_list": [
    //     {
    //       "post_id": "990148689040560135",
    //       "post_url": "https://x.com/ZY/status/990148689040560135",
    //       "content": "",
    //       "image_url": "https://pbs.twimg.com/media/Db22--GVAAAeChW.jpg",
    //       "video_url": null,
    //       "comment_count": 7,
    //       "repost_count": 0,
    //       "like_count": 12,
    //       "publish_time": "2018-04-28 08:40:18",
    //       "risk": "High",
    //       "reason": "The post contains several risk tags, which are indicators of potential issues or violations of platform guidelines. These tags include inappropriate use of hashtags, language, and content that might be considered harmful or misleading. Each tag corresponds to specific behaviors or content types that are often monitored and controlled to maintain a safe and respectful online environment. Below is an analysis of the risk associated with these tags:"
    //     },
    //     {
    //       "post_id": "990148689040560135",
    //       "post_url": "https://x.com/ZY/status/990148689040560135",
    //       "content": "Milestone: 50M compute units online within 5 years—efficiency > power.",
    //       "image_url": "https://pbs.twimg.com/media/Db22--GVAAAeChW.jpg",
    //       "video_url": null,
    //       "comment_count": 7,
    //       "repost_count": 0,
    //       "like_count": 12,
    //       "publish_time": "2018-04-28 08:40:18",
    //       "risk": "Low",
    //       "reason": "The post contains several risk tags, which are indicators of potential issues or violations of platform guidelines. These tags include inappropriate use of hashtags, language, and content that might be considered harmful or misleading. Each tag corresponds to specific behaviors or content types that are often monitored and controlled to maintain a safe and respectful online environment. Below is an analysis of the risk associated with these tags:"
    //     },

    //     {
    //       "post_id": "990148689040560135",
    //       "post_url": "https://x.com/ZY/status/990148689040560135",
    //       "content": "Milestone: 50M compute units online within 5 years—efficiency > power.",
    //       "image_url": "https://pbs.twimg.com/media/Db22--GVAAAeChW.jpg",
    //       "video_url": null,
    //       "comment_count": 7,
    //       "repost_count": 0,
    //       "like_count": 12,
    //       "publish_time": "2018-04-28 08:40:18",
    //       "risk": "Low",
    //       "reason": "The post contains several risk tags, which are indicators of potential issues or violations of platform guidelines. These tags include inappropriate use of hashtags, language, and content that might be considered harmful or misleading. Each tag corresponds to specific behaviors or content types that are often monitored and controlled to maintain a safe and respectful online environment. Below is an analysis of the risk associated with these tags:"
    //     },
    //     {
    //       "post_id": "990148689040560135",
    //       "post_url": "https://x.com/ZY/status/990148689040560135",
    //       "content": "",
    //       "image_url": "https://pbs.twimg.com/media/Db22--GVAAAeChW.jpg",
    //       "video_url": null,
    //       "comment_count": 7,
    //       "repost_count": 0,
    //       "like_count": 12,
    //       "publish_time": "2018-04-28 08:40:18",
    //       "risk": "High",
    //       "reason": "The post contains several risk tags, which are indicators of potential issues or violations of platform guidelines. These tags include inappropriate use of hashtags, language, and content that might be considered harmful or misleading. Each tag corresponds to specific behaviors or content types that are often monitored and controlled to maintain a safe and respectful online environment. Below is an analysis of the risk associated with these tags:"
    //     },
    //     {
    //       "post_id": "990148689040560135",
    //       "post_url": "https://x.com/ZY/status/990148689040560135",
    //       "content": "",
    //       "image_url": "https://pbs.twimg.com/media/Db22--GVAAAeChW.jpg",
    //       "video_url": null,
    //       "comment_count": 7,
    //       "repost_count": 0,
    //       "like_count": 12,
    //       "publish_time": "2018-04-28 08:40:18",
    //       "risk": "High",
    //       "reason": "The post contains several risk tags, which are indicators of potential issues or violations of platform guidelines. These tags include inappropriate use of hashtags, language, and content that might be considered harmful or misleading. Each tag corresponds to specific behaviors or content types that are often monitored and controlled to maintain a safe and respectful online environment. Below is an analysis of the risk associated with these tags:"
    //     }
    //   ]
    // })
    // setLoading(false);
    // setMyTask({
    //   ...myTask,
    //   status: 'completed',
    // });
    // return;

    if (res.code === 0) {
      // ga_logEvent(EventName.input_reverse_username);
      // ga_logEvent(EventName.click_username_search);
      // callBackName(res.data, 'reverse-username-search', username);
      // 10 秒后才处理结果
      setTimeout(() => {
        setLoading(false);
        setMyTask({
          ...myTask,
          status: 'completed',
        });
        setData(res.data);
        // 滚动到结果组件
        setTimeout(() => handleScrollToResult(), 100);
      }, 10000);
    } else {
      setLoading(false);
      handleToTop();
      setMyTask({
        ...myTask,
        status: 'failed',
      });
    }
  }

  function handleScrollToResult() {
    if (resultRef.current) {
      const isMobile = window.innerWidth <= 768;
      const offset = isMobile ? 20 : 100;
      const elementPosition = resultRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  function handleToTop() {
    scrollTo({ top: 0, behavior: 'smooth' });
  }

  const showError = myTask && myTask?.status === 'failed';
  const showResult = myTask && !showError && myTask?.status === 'completed';
  const showSearching = myTask && loading;

  return (
    <>
      <div className={styles.container}>
        <Hero
          landingData={content}
          currentTab={currentTab}
          setCurrentTabAction={setCurrentTab}
          // tabRedirect={tabRedirect}
          tabRedirect={false}
          isSubPage={isSubPage}
        >
          <div className={styles.searchBox}>
            <input
              ref={inputRef}
              className={styles.searchInput}
              placeholder={t('Enter username or profile URL')}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  startShadowbanAction();
                }
              }}
            />
            <button
              className={styles.searchButton}
              style={{
                boxShadow: '0px 2px 1px 0px #FFFFFF33 inset, 0px -2px 1px 0px #03207033 inset',
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
              disabled={loading}
              onClick={() => startShadowbanAction()}
            >
              {loading && <LoaderCircle size={16} className={styles.spinIcon} />}
              {content.contentInfo['hero'].buttonText}
            </button>
          </div>

          {/* Feature Cards */}
          {content.contentInfo['hero'].cards && content.contentInfo['hero'].cards.length > 0 && (
            <div className={styles.featureCards}>
              {content.contentInfo['hero'].cards.map(
                (card: any, index: number) =>
                  card.title && (
                    <div key={index} className={styles.cardItem}>
                      <svg
                        className={styles.cardIcon}
                        viewBox="0 0 20 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.5 5.73077L7.97619 12.5L18.5 1.5"
                          stroke="#38C13D"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className={styles.cardText}>{card.title}</span>
                    </div>
                  ),
              )}
            </div>
          )}
        </Hero>
        {(!myTask || myTask?.status === 'failed') && (
          <div className={styles.imageContainer}>
            <Image
              width={916}
              height={454}
              src={content.contentInfo['hero'].imgPath}
              alt={content.contentInfo['hero'].title}
              className={styles.heroImage}
            />
          </div>
        )}
        {showSearching && <Searching />}
        {showResult && (
          <div ref={resultRef}>
            <SearchResult data={data} />
          </div>
        )}
        {showError && (
          <SearchError
            onClose={() => {
              setMyTask(null);
              setLoading(false);
            }}
            onTryAgainClick={() => {
              setMyTask(null);
              setLoading(false);
              if (inputRef.current) {
                inputRef.current.value = '';
                inputRef.current.focus();
              }
            }}
          />
        )}
        <LandingPage landingData={content} />
      </div>
      <LandingFooter landingData={content} handleToTop={handleToTop} />
    </>
  );
};

export default Index;
